module.exports = __webpack_public_path__ + "static/wechat-zh-f6af5800cc1c10e343e78163b3ee3233.jpg";